"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageAnalyze = void 0;
var ProductList_1 = __importDefault(require("./models/ProductList"));
var SearchInfo_1 = __importDefault(require("./models/SearchInfo"));
var getProductData_1 = require("./helpers/getProductData");
/**
 * Klasa analizująca DOM i location strony w celu uzyskania konkretnych informacji na jej temat
 */
var PageAnalyze = /** @class */ (function () {
    function PageAnalyze(document, location) {
        this.doc = document;
        this.location = location;
    }
    /**
     * Pobierz aktualną ścieżkę
     * @return {string}
     */
    PageAnalyze.prototype.getLocationPath = function () {
        return decodeURIComponent(this.location.pathname);
    };
    /**
     * Pobierz produkty zawarte na stronie (lub we wskazanym kontenerze)
     * @param {Element} container Opcjonalny element, w ramach którego ma być wykonywane
     * wyszukiwanie
     * @return {NodeListOf<Element>}
     */
    PageAnalyze.prototype.getProductContainers = function (container) {
        var elementsList;
        var match = '[itemscope][itemtype="http://schema.org/Product"]';
        if (typeof container === 'undefined') {
            elementsList = this.doc.querySelectorAll(match);
        }
        else {
            elementsList = container.querySelectorAll(match);
        }
        return elementsList;
    };
    /**
     * Pobierz kontenery przechowujące listy produktowe
     * @return {NodeListOf<Element>}
     */
    PageAnalyze.prototype.getProductsListContainers = function () {
        return this.doc.querySelectorAll('.products-container');
    };
    /**
     * Wygeneruj parametry z listami produktów
     * @param {Element} listsContainer Opcjonalny element, w ramach którego ma być wykonane
     * wyszukiwanie
     * @param {Object} data
     */
    PageAnalyze.prototype.getProductsLists = function (listsContainer) {
        var _this = this;
        // Lista produktów widocznych na stronie
        var list = [];
        var lists;
        if (typeof listsContainer === 'undefined') {
            lists = this.doc.querySelectorAll('.products-container');
        }
        else {
            lists = listsContainer.querySelectorAll('.products-container');
        }
        lists.forEach(function (container) {
            var mainList = _this.getProductListData(container);
            if (mainList.productList.length > 0) {
                list.push(mainList);
            }
        });
        return list;
    };
    /**
     * Wygeneruj obiekt ProductList na podstawie kontenera przechowującego listę produktów
     * @param {Element} container
     * @return {ProductList}
     */
    PageAnalyze.prototype.getProductListData = function (container) {
        var mainList = new ProductList_1.default();
        var titleAttr = container.attributes.getNamedItem('data-title');
        if (titleAttr !== null) {
            mainList.name = titleAttr.value.trim();
        }
        if (mainList.name === '') {
            var h1 = this.getFirstHeader();
            if (h1 !== null) {
                mainList.name = h1;
            }
            else {
                mainList.name = this.getBreadcrumbs().join(' > ');
            }
        }
        var typeAttr = container.attributes.getNamedItem('data-type');
        if (typeAttr === null) {
            mainList.template = 'special offers';
        }
        else if (typeAttr.value === 'category') {
            mainList.template = 'category';
        }
        else if (typeAttr.value === 'search') {
            mainList.template = 'search results';
        }
        else if (typeAttr.value === 'promotion page') {
            mainList.template = 'campaign';
        }
        else if (typeAttr.value === 'cross selling') {
            mainList.template = 'cross-selling';
        }
        else if (typeAttr.value === 'openset') {
            mainList.template = 'openset';
        }
        else if (typeAttr.value === 'cart') {
            mainList.template = 'cart';
        }
        else {
            mainList.template = 'special offers';
        }
        var products = this.getProductContainers(container);
        var i = 0;
        products.forEach(function (product) {
            var productRow = getProductData_1.getProductData(product);
            if (productRow !== null) {
                productRow.position = i;
                mainList.productList.push(productRow);
                mainList.size += 1;
                i += 1;
            }
        });
        return mainList;
    };
    /**
     * Pobierz tekst zawarty w H1
     * @return {string|null}
     */
    PageAnalyze.prototype.getFirstHeader = function () {
        var header = this.doc.querySelector('h1');
        if (header !== null) {
            return header.textContent ? header.textContent.trim() : null;
        }
        return null;
    };
    /**
     * Pobierz aktualny krok w koszyku
     * @return {number|null}
     */
    PageAnalyze.prototype.getCheckoutStep = function () {
        if (this.location.pathname.indexOf('/cart') === -1) {
            return null;
        }
        if (this.location.pathname.indexOf('/cart/prepayment') !== -1
            || this.location.pathname.indexOf('/cart/orderfail') !== -1
            || this.location.pathname.indexOf('/cart/orderend') !== -1
            || this.location.pathname.indexOf('/cart/repay') !== -1) {
            return 3;
        }
        if (this.location.pathname.indexOf('/cart/delivery') !== -1
            || this.location.pathname.indexOf('/cart/payment') !== -1
            || this.location.pathname.indexOf('/auth/index/from/cart') !== -1) {
            return 2;
        }
        return 1;
    };
    /**
     * Pobierz nazwy poszczególnych elementów breadcrumba
     * @return string[]
     */
    PageAnalyze.prototype.getBreadcrumbs = function () {
        var names = [];
        var breadcrumbs = this.doc.querySelectorAll('[itemscope][itemtype="http://schema.org/BreadcrumbList"] [itemprop="name"]');
        if (breadcrumbs.length > 0) {
            breadcrumbs.forEach(function (element) {
                if (typeof element.textContent === 'string') {
                    names.push((element.textContent || '').trim());
                }
            });
        }
        return names;
    };
    /**
     * Pobierz informacje o ustawieniach/wynikach wyszukiwania na obecnej stronie
     * @return {SearchInfo}
     */
    PageAnalyze.prototype.getSearchInfo = function () {
        var info = new SearchInfo_1.default();
        var searchInfo = this.doc.querySelectorAll('.search-results .result-list-products-head__found .nbr');
        if (searchInfo.length > 0) {
            info.phrase = searchInfo[0].textContent;
            info.totalProducts = parseInt(searchInfo[1].textContent || '0', 10);
        }
        return info;
    };
    /**
     * Pobierz przyciski logowania
     * @return {NodeListOf<Element>}
     */
    PageAnalyze.prototype.getLoginButtons = function () {
        return this.doc.querySelectorAll('.login-page__left #login-page__form .submit');
    };
    /**
     * Pobierz przyciski otwierające(i zamykające) listy kolorów
     * @return {NodeListOf<Element>}
     */
    PageAnalyze.prototype.getColorChartOpenCloseButtons = function () {
        return this.doc.querySelectorAll('.product-card__overview-all-colors span');
    };
    /**
     * Pobierz kontener zawierający produkt (na stronie produktu)
     * @return {Element|null}
     */
    PageAnalyze.prototype.getProductContainer = function () {
        return this.doc.querySelector('.product-page[itemscope][itemtype="http://schema.org/Product"] .product-card');
    };
    /**
     * Pobierz przyciski dodawania do koszyka z poziomu karty produktu
     * @return {NodeListOf<Element>}
     */
    PageAnalyze.prototype.getProductPageCartButtons = function () {
        return this.doc.querySelectorAll('.product-page[itemscope][itemtype="http://schema.org/Product"] cart-add');
    };
    /**
     * Pobierz etykiety filtrów
     *
     * UWAGA: Dotyczy tylko wersji desktopowej
     * @return {NodeListOf<Element>}
     */
    PageAnalyze.prototype.getFilterLabels = function () {
        return this.doc.querySelectorAll('.filter label[data-id]');
    };
    /**
     * Pobierz etykiety wybranych filtrów (lista elementów w nawigacji "wybrane filtry")
     *
     * UWAGA: Dotyczy tylko wersji desktopowej
     * @return {NodeListOf<Element>}
     */
    PageAnalyze.prototype.getSelectedFiltersLabels = function () {
        return this.doc.querySelectorAll('.filter-selection__list li a[data-url-name]');
    };
    /**
     * Pobierz selecty używane do filtrowania w wersji mobilnej
     * @return {NodeListOf<Element>}
     */
    PageAnalyze.prototype.getFilterSelects = function () {
        return this.doc.querySelectorAll('.filters select');
    };
    /**
     * Pobierz selecty używane do sortowania
     */
    PageAnalyze.prototype.getSortSelects = function () {
        return this.doc.querySelectorAll('.service__field--select select, .filter-sort select');
    };
    /**
     * Pobierz przyciski kończące zamówienie ("Potwierdzam zakup")
     * @return {NodeListOf<Element>}
     */
    PageAnalyze.prototype.getCartConfirmButton = function () {
        return this.doc.querySelectorAll('.btn-finalize-order, .js-finalize-order');
    };
    /**
     * Pobierz przyciski zatwierdzające formularz płatności
     * @return {NodeListOf<Element>}
     */
    PageAnalyze.prototype.getPaymentButton = function () {
        return this.doc.querySelectorAll('.prepayment-goto');
    };
    /**
     * Pobierz wszystkie linki z menu górnego
     * @return {NodeListOf<Element>}
     */
    PageAnalyze.prototype.getTopMenuAnchors = function () {
        return this.doc.querySelectorAll('.top-menu a');
    };
    /**
     * Pobierz przyciski kierujące do rejestracji jednorazowej
     * @return {NodeListOf<Element>}
     */
    PageAnalyze.prototype.getOnetimeRegisterButtons = function () {
        return this.doc.querySelectorAll('a[href^="/customer/register/step/onetime"]');
    };
    /**
     * Pobierz formularze dodawania produktu do koszyka z użyciem SKU
     * @return {NodeListOf<Element>}
     */
    PageAnalyze.prototype.getAddBySkuForms = function () {
        return this.doc.querySelectorAll('#cartAdd');
    };
    /**
     * Pobierz formularze subskrypcji newslettera (przenoszące na /newsletter/subscribe)
     * @return {NodeListOf<Element>}
     */
    PageAnalyze.prototype.getNewsletterForms = function () {
        return this.doc.querySelectorAll('form[action="/newsletter"]');
    };
    /**
     * Pobierz formularz zapisu do newslettera (obecny tylko na /newsletter/subscribe)
     * @return {Element|null}
     */
    PageAnalyze.prototype.getNewsletterSubscriptionForm = function () {
        return this.doc.querySelector('#newsletter-form');
    };
    /**
     * Pobierz przyciski "Zapomniałem hasło"
     * @return {NodeListOf<Element>}
     */
    PageAnalyze.prototype.getLostPasswordButtons = function () {
        return this.doc.querySelectorAll('.js-show-reminder-form');
    };
    /**
     * Pobierz przyciski zatwierdzające formularz resetowania hasła
     * @return {NodeListOf<Element>}
     */
    PageAnalyze.prototype.getLostPasswordSubmits = function () {
        return this.doc.querySelectorAll('.reset-pass-form button');
    };
    /**
     * Czy aktualna strona jest stroną autoryzacji?
     * @return {boolean}
     */
    PageAnalyze.prototype.isAuthPage = function () {
        return this.location.pathname.indexOf('/auth') === 0;
    };
    return PageAnalyze;
}());
exports.PageAnalyze = PageAnalyze;
exports.default = PageAnalyze;
